import React from 'react'

const WithdrawalEN = () => {
    return (
        <>
            <meta content="text/html; charset=UTF-8" httpEquiv="content-type" />
            <style
                type="text/css"
                dangerouslySetInnerHTML={{
                    __html: 'ol{margin:0;padding:0}table td,table th{padding:0}.c0{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:12pt;font-family:"Albert Sans";font-style:normal}.c5{padding-top:0pt;padding-bottom:10pt;line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}.c8{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-family:"Albert Sans";font-style:normal}.c1{padding-top:0pt;padding-bottom:10pt;line-height:1.1500000000000001;orphans:2;widows:2;text-align:justify}.c2{text-decoration-skip-ink:none;font-size:12pt;-webkit-text-decoration-skip:none;color:#1155cc;text-decoration:underline}.c9{background-color:#ffffff;max-width:451.5pt;padding:72pt 72pt 72pt 72pt}.c3{color:inherit;text-decoration:inherit}.c6{font-size:26pt}.c4{height:11pt}.c7{font-size:12pt}.title{padding-top:0pt;color:#000000;font-size:26pt;padding-bottom:3pt;font-family:"Albert Sans";line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}.subtitle{padding-top:0pt;color:#666666;font-size:15pt;padding-bottom:16pt;font-family:"Albert Sans";line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}li{color:#000000;font-size:11pt;font-family:"Albert Sans"}p{margin:0;color:#000000;font-size:11pt;font-family:"Albert Sans"}h1{padding-top:20pt;color:#000000;font-size:20pt;padding-bottom:6pt;font-family:"Albert Sans";line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}h2{padding-top:18pt;color:#000000;font-size:16pt;padding-bottom:6pt;font-family:"Albert Sans";line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}h3{padding-top:16pt;color:#434343;font-size:14pt;padding-bottom:4pt;font-family:"Albert Sans";line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}h4{padding-top:14pt;color:#666666;font-size:12pt;padding-bottom:4pt;font-family:"Albert Sans";line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}h5{padding-top:12pt;color:#666666;font-size:11pt;padding-bottom:4pt;font-family:"Albert Sans";line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}h6{padding-top:12pt;color:#666666;font-size:11pt;padding-bottom:4pt;font-family:"Albert Sans";line-height:1.1500000000000001;page-break-after:avoid;font-style:italic;orphans:2;widows:2;text-align:left}'
                }}
            />
            <p className="c1">
                <span className="c0">Instructions on withdrawal</span>
            </p>
            <p className="c1">
                <span className="c0">As of March 2024 </span>
            </p>
            <p className="c1">
                <span className="c0">
                    If the tenant is a consumer, the following rules apply to the conclusion of the lease:
                </span>
            </p>
            <p className="c1">
                <span className="c0">Right of withdrawal</span>
            </p>
            <p className="c1">
                <span className="c7">
                    The consumer has the right to revoke from this contract within fourteen days without giving any
                    reason. The fourteen-day revocation period begins with the conclusion of the contract. The
                    revocation must be declared to the landlord. Revocation declarations can also be made for this
                    purpose to Wemolo GmbH (St.-Martin-Straße 72, 81541 Munich, phone: +49 89 693146491,{' '}
                </span>
                <span className="c2">
                    <a className="c3" href="mailto:book@wemolo.com">
                        book@wemolo.com
                    </a>
                </span>
                <span className="c0">
                    ) (e.g. by letter, fax or email), which is authorized by the landlord to receive such declarations.
                    The decision to withdraw from the contract must be clearly stated in this declaration. The consumer
                    may use the attached sample withdrawal form for this purpose. Timely dispatch of the revocation is
                    sufficient to meet the deadline.{' '}
                </span>
            </p>
            <p className="c1">
                <span className="c0">Consequences of withdrawal</span>
            </p>
            <p className="c1">
                <span className="c0">
                    If the consumer revokes the contract, all payments that have already been made by the consumer at
                    that time will be refunded by Wemolo GmbH immediately and at the latest within fourteen days of
                    receipt of the declaration of revocation. The refund will be made using the same means of payment
                    that was used for the original transaction. Any fees in connection with the repayment will not be
                    charged.{' '}
                </span>
            </p>
            <p className="c1">
                <span className="c0">
                    If the tenant expressly requests that the parking space be handed over to him for use in accordance
                    with the contract before the end of the fourteen-day revocation period, the pro rata rent incurred
                    in this period up to receipt of the revocation shall be retained as compensation for the services
                    already provided.
                </span>
            </p>
            <p className="c1">
                <span className="c0">End of the withdrawal instruction</span>
            </p>
            <hr />
            <p className="c1 c4">
                <span className="c0" />
            </p>
            <p className="c1">
                <span className="c0">Sample withdrawal form</span>
            </p>
            <p className="c1">
                <span className="c0">
                    (If you wish to withdraw from the contract, please fill out this form and send it back.)
                </span>
            </p>
            <p className="c1">
                <span className="c7">To Wemolo GmbH, St.-Martin-Straße 72, 81541 Munich, </span>
                <span className="c2">
                    <a className="c3" href="mailto:book@wemolo.com">
                        book@wemolo.com
                    </a>
                </span>
                <span className="c0">:</span>
            </p>
            <p className="c1">
                <span className="c0">I/We (*) hereby revoke the rental agreement concluded by me/us (*)</span>
            </p>
            <p className="c1">
                <span className="c0">Ordered on (*)/received on (*)</span>
            </p>
            <p className="c1">
                <span className="c0">Name of the consumer(s)</span>
            </p>
            <p className="c1">
                <span className="c0">Address of the consumer(s)</span>
            </p>
            <p className="c1">
                <span className="c0">Signature of the consumer(s) (only in the case of notification on paper)</span>
            </p>
            <p className="c1">
                <span className="c0">Date</span>
            </p>
            <p className="c1">
                <span className="c0">(*) Delete as appropriate</span>
            </p>
            <p className="c1 c4">
                <span className="c0" />
            </p>
            <hr />
            <p className="c1 c4">
                <span className="c0" />
            </p>
            <p className="c1 c4">
                <span className="c0" />
            </p>
            <p className="c1">
                <span className="c0">Instructions on withdrawal Austria</span>
            </p>
            <p className="c1">
                <span className="c0">As of March 2024 </span>
            </p>
            <p className="c1">
                <span className="c0">
                    If the tenant is a consumer, the following regulations apply to the conclusion of the rental
                    agreement
                </span>
            </p>
            <p className="c1">
                <span className="c0">Right of withdrawal</span>
            </p>
            <p className="c1">
                <span className="c7">
                    The consumer has the right to revoke from this contract within fourteen days without giving reasons.
                    The fourteen-day revocation period begins with the conclusion of the contract. The revocation must
                    be declared to the landlord. Revocation declarations can also be made for this purpose to ParkDepot
                    GmbH, Siezenheimerstraße 35, 5020 Salzburg, phone.: +43 720 880680,{' '}
                </span>
                <span className="c2">
                    <a className="c3" href="mailto:book@wemolo.at">
                        book@wemolo.at
                    </a>
                </span>
                <span className="c0">
                    ), (e.g. by letter, fax or email), which is authorized by the landlord to receive such declarations.
                    The decision to withdraw from the contract must be clearly stated in this declaration. The consumer
                    may use the attached sample withdrawal form for this purpose. Timely dispatch of the revocation is
                    sufficient to meet the deadline.{' '}
                </span>
            </p>
            <p className="c1">
                <span className="c0">Consequences of withdrawal</span>
            </p>
            <p className="c1">
                <span className="c0">
                    If the consumer withdraws from the contract, all payments already made by the consumer at that time
                    will be refunded by ParkDepot GmbH immediately and at the latest within fourteen days of receipt of
                    the declaration of withdrawal. Repayment will be made using the same means of payment that was used
                    for the original transaction. Any fees in connection with the repayment will not be charged.{' '}
                </span>
            </p>
            <p className="c1">
                <span className="c0">
                    If the tenant expressly requests that the parking space be handed over to him for use in accordance
                    with the contract before the end of the fourteen-day revocation period, the pro rata rent incurred
                    in this period up to receipt of the revocation shall be retained as compensation for the services
                    already provided.
                </span>
            </p>
            <p className="c1">
                <span className="c0">End of the withdrawal instruction</span>
            </p>
            <hr />
            <p className="c1 c4">
                <span className="c0" />
            </p>
            <p className="c1">
                <span className="c0">Sample withdrawal form</span>
            </p>
            <p className="c1">
                <span className="c0">
                    (If you wish to withdraw from the contract, please fill out this form and send it back.)
                </span>
            </p>
            <p className="c1">
                <span className="c7">
                    To ParkDepot GmbH, Siezenheimerstraße 35, 5020 Salzburg, phone: +43 720 880680,{' '}
                </span>
                <span className="c2">
                    <a className="c3" href="mailto:book@wemolo.at">
                        book@wemolo.at
                    </a>
                </span>
                <span className="c0">:</span>
            </p>
            <p className="c1">
                <span className="c0">I/we (*) hereby revoke the rental agreement concluded by me/us (*)</span>
            </p>
            <p className="c1">
                <span className="c0">Ordered on (*)/received on (*)</span>
            </p>
            <p className="c1">
                <span className="c0">Name of the consumer(s)</span>
            </p>
            <p className="c1">
                <span className="c0">Address of the consumer(s)</span>
            </p>
            <p className="c1">
                <span className="c0">Signature of the consumer(s) (only in the case of notification on paper)</span>
            </p>
            <p className="c1">
                <span className="c0">Date</span>
            </p>
            <p className="c1">
                <span className="c0">(*) Delete as appropriate</span>
            </p>
            <p className="c1 c4">
                <span className="c0" />
            </p>
        </>
    )
}

export default WithdrawalEN
